import DisclaimerService, {
  type Disclaimer,
  type DisclaimerCheck,
  type DisclaimerResponse,
  type DisclaimerValidation,
} from '@/services/disclaimer';
import { useMutation, useQuery } from '@tanstack/react-query';

// Get all disclaimers
export const useDisclaimers = () => {
  return useQuery<DisclaimerResponse>({
    queryKey: ['disclaimers'],
    queryFn: async () => {
      const response = await DisclaimerService.getDisclaimers();
      return response as DisclaimerResponse;
    },
  });
};

// Get single disclaimer by ID
export const useDisclaimer = (id: number) => {
  return useQuery<Disclaimer>({
    queryKey: ['disclaimer', id],
    queryFn: async () => {
      const response = await DisclaimerService.getDisclaimersById(id);
      return response as Disclaimer;
    },
    enabled: !!id, // Only run if ID is provided
  });
};

// Validate user disclaimer status
export const useValidateDisclaimer = () => {
  return useQuery<DisclaimerValidation>({
    queryKey: ['validate-disclaimer'],
    queryFn: async () => {
      const response = await DisclaimerService.validateDisclaimer();
      return response.data;
    },
  });
};

// Update user disclaimer acceptance
export const useUpdateDisclaimerCheck = () => {
  return useMutation<DisclaimerCheck, Error, DisclaimerCheck>({
    mutationFn: async (disclaimerCheck) => {
      const { data } =
        await DisclaimerService.updateDisclaimerCheck(disclaimerCheck);
      return data;
    },
  });
};
